import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PromoteFlowDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useFetchContractsPermissions } from 'modules/contracts/hooks/useFetchContractsPermissions'
import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import PromoteFlowContent from './_PromoteFlowContent'

const Loading = () => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

const PromoteFlow = () => {
  const { employee } = useContractFlow()
  const { company } = useCurrentSession()
  const { data, loading: loadingPromoteFlow } = useQuery(PromoteFlowDocument, {
    variables: { companyId: company.id },
  })
  const { loading: loadingPermissions } = useFetchContractsPermissions(employee)

  if (loadingPermissions || loadingPromoteFlow) return <Loading />
  const canPromote = policyAuthorizations.for('contracts.promote', employee)
  if (!canPromote) return <NotFound />

  const jobCatalogTreeFeatureEnabled = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_job_catalog_tree'
  )?.enabled

  return (
    <PromoteFlowContent
      jobCatalogTrees={data?.jobCatalog?.treesConnection?.nodes}
      jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
    />
  )
}

export default observer(PromoteFlow)
